import { render, staticRenderFns } from "./editBoton.vue?vue&type=template&id=567af1c5"
import script from "./editBoton.vue?vue&type=script&lang=js"
export * from "./editBoton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports